<div class="my-2">
    @if (tableData) {
    <app-report-multiple-input-filter [tableFilters]="tableData.data.tableFilters"
        (selectedFilter)="onSelectedFilter($event)"></app-report-multiple-input-filter>
    }
</div>

<div class="table-container mat-elevation-z6">
    @if (isLoadingResults) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
    </div>
    }

    @if (tableData) {
    <div>
        @if (showReportMessage) {
        <div><b>{{ reportMessage}}</b></div>
        }
        @for (data of tableData.data.tableRows; track $index) {
        <table style="width:100%; margin-top: 10pt; border: 0;">
            <tr>
                <th>Status</th>
                @for (s of data.status; track $index; let i = $index) {
                <td class="right"
                    [style.backgroundColor]="customIndex(i,data.status) == true ? 'lawngreen' : customIndexClosed(i,data.status) == true ? 'lightgreen' : customIndexMatched(i,data.status) == true ? 'palegoldenrod': customIndexInvoiced(i,data.status) == true ? '#0f812d': ''">
                    {{s}}
                </td>
                }
            </tr>
            @for (types of data.types; track $index) {
            <tr>
                <th>{{ types.type }}</th>
                @for (count of types.count; track $index; let j = $index) {
                <td class="right"
                    [style.backgroundColor]="customIndex(j,data.status) == true ? 'lawngreen' : customIndexClosed(j,data.status) == true ? 'lightgreen' : customIndexMatched(j,data.status) == true ? 'palegoldenrod': customIndexInvoiced(j,data.status) == true ? '#0f812d': ''">
                    {{count}}
                </td>
                }
                <td>{{ types.total}}</td>
            </tr>
            }
            <tr>
                <th>Percentage</th>
                @for (percentage of data.percentage; track $index; let k = $index) {
                <td class="right"
                    [style.backgroundColor]="customIndex(k,data.status) == true ? 'lawngreen' : customIndexClosed(k,data.status) == true ? 'lightgreen': customIndexMatched(k,data.status) == true ? 'palegoldenrod': customIndexInvoiced(k,data.status) == true ? '#0f812d': ''">
                    {{percentage}}
                </td>
                }
                <td>{{data.mainTotal}}</td>
            </tr>
        </table>
        }
    </div>
    }
</div>